export const STORAGE_KEY = 'accessToken';
export const STORAGE_USER_KEY = 'user';

export const getSessionToken = () => {
    return localStorage.getItem(STORAGE_KEY);
};

export const setSession = (accessToken) => {
    if (accessToken) {
        localStorage.setItem(STORAGE_KEY, accessToken);
    } else {
        localStorage.removeItem(STORAGE_KEY);
        localStorage.removeItem(STORAGE_USER_KEY);
    }
};
